import { useEffect, useState } from 'react';

type useFlatExportT = {
    shouldShowOpenedGroups: boolean;
    setShouldShowOpenedGroups: (shouldShowOpenedGroups: boolean) => void;
};

/**
 * Custom hook to manage the state for starting a flat export process.
 *
 * It provides a way to trigger an export function when `setShouldShowOpenedGroups(true)` is called
 * and then resets the state back to false. `shouldShowOpenedGroups` should be used to update
 * the AG-Grid Property `showOpenedGroup`.
 *
 * @param {function} exportFunction - The function to be executed when starting the export.
 * @returns {object} An object containing the `shouldShowOpenedGroups` state and the `setShouldShowOpenedGroups` function.
 */
export const useFlatExport = (exportFunction: () => void): useFlatExportT => {
    const [shouldShowOpenedGroups, setShouldShowOpenedGroups] = useState(false);

    useEffect(() => {
        if (shouldShowOpenedGroups) {
            exportFunction();
            setShouldShowOpenedGroups(false);
        }
    }, [shouldShowOpenedGroups]);

    return { shouldShowOpenedGroups, setShouldShowOpenedGroups };
};
